import React, { useEffect } from 'react'
// import { useParams } from 'react-router-dom'

import { ClipboardListIcon } from '@heroicons/react/outline'
import GoalStepper from 'components/Owner/Goal/GoalDetail/GoalStepper'
import Button from 'components/Common/Button'
// import history from 'utils/history'

import { GOAL_ACTION } from 'config'
import GreenCheck from 'components/Common/SvgIcons/GreenCheck'
import WhiteCheck from 'components/Common/SvgIcons/WhiteCheck'
import { ClipBoardPen } from 'components/Common/SvgIcons'

export default function GoalDetail({
  goalDetails,
  currentGoal,
  handleUserGoal,
  getUserGoalAction,
  getGoalDetailsAction,
  getAssessmentQuestionAction,
}) {
  // let { tenantId } = useParams()

  useEffect(() => {
    getUserGoalAction()
    getAssessmentQuestionAction({ type: 'initial' })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getGoalDetailsAction, getAssessmentQuestionAction])

  useEffect(() => {
    if (currentGoal?.id) {
      getGoalDetailsAction(currentGoal.id)
    }
  }, [currentGoal, getGoalDetailsAction])

  return (
    <>
      <div className="h-screen w-full bg-white lg:bg-playbook-bg xl:bg-playbook-bg font-primary	">
        <div className="w-screen h-[86px] px-4 bg-white border-b border-grey-darker">
          <div className="flex justify-between pb-4 w-full h-full">
            <div className="flex items-end ">
              {/* Removed until playbooks page fixed */}
              {/* <ChevronLeftIcon
                className="w-[22px]  h-[27.5px]  inline-block"
                onClick={() => history.push(`/owner/${tenantId}/playbooks`)}
              /> */}
            </div>

            <div className="flex items-end h-full">
              <p className="font-normal  w-full text-lg font-bold text-black-light">Goal Details</p>
            </div>

            <div className={`flex items-end  h-full min-w-[20px]`}>
              <div className={`${!currentGoal?.isTopGoal && 'hidden'}`}>
                <GreenCheck />
              </div>
            </div>
          </div>
        </div>

        {currentGoal?.isTopGoal ? (
          <div className="w-screen h-[35px] bg-primary">
            <div className="flex items-center justify-center w-full h-full">
              <div className="inline-flex text-white">
                This active goal is currently your&ensp; <p className="underline ">top goal</p>
              </div>
            </div>
          </div>
        ) : (
          <>
            {currentGoal?.isActiveGoal && (
              <div className="w-screen h-[35px]  bg-primary ">
                <div className="flex items-center justify-center w-full h-full">
                  <div className="inline-flex text-white">
                    This goal is currently&ensp; <p className="underline ">active</p>
                  </div>
                </div>
              </div>
            )}
          </>
        )}

        <div className="pt-4 bg-white">
          <div className="flex justify-center w-full h-full">
            <div className="xl:w-[1400px] ">
              <div className="grid md:grid-cols-5 md:gap-4 xs:min-w-[333px]">
                <div className="xs:col-span-5 sm:col-span-5 md:col-span-2  h-full w-full">
                  <div className="grid gap-4">
                    <div className="row-span-3 rounded-[10px] min-h-[191px] xs:min-w-[333px]  w-full bg-grey-darker" />
                    <div className="row-span-2 ">
                      <div className="grid p-4 gap-4 rounded-lg bg-white w-full">
                        <div className="row-span-1 ">
                          <p className="font-normal max-w-[377px] w-full max-h-[25px] text-lg font-bold text-primary-text">
                            {goalDetails?.name}
                          </p>
                        </div>

                        <div className="row-span-1">
                          <div className="flex text-primary-text font-normal text-sm">
                            <div className="inline-flex text-center items-center">
                              <div>
                                <ClipboardListIcon className="w-6 h-6" />
                              </div>

                              <div className="ml-2.5">3 Playbooks</div>
                            </div>

                            <div className="ml-[23px] inline-flex text-center items-center">
                              <ClipBoardPen />

                              <div className="ml-2.5">1 Assessment</div>
                            </div>
                          </div>
                        </div>
                        <div className="row-span-2 ">
                          <p className="font-normal text-sm text-silver">
                            {goalDetails?.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="xs:col-span-5 sm:col-span-5 md:col-span-3 md:mt-0 xs:mt-[20px] h-max w-full rounded-lg bg-white">
                  <GoalStepper />

                  <div className="sticky bottom-0 h-full w-full pb-2 bg-white">
                    {currentGoal?.isActiveGoal ? (
                      <>
                        {currentGoal?.isTopGoal ? (
                          <div className="w-full">
                            {/* check-button -- clean up custom style */}
                            <Button
                              onClick={() => handleUserGoal(GOAL_ACTION.INACTIVE)}
                              variant="secondary"
                              className="outline-black !text-black w-full"
                              label="Mark this goal inactive"
                            />
                          </div>
                        ) : (
                          <>
                            <div className="w-full relative">
                              {/* check-button -- clean up custom style */}
                              <Button
                                onClick={() => handleUserGoal(GOAL_ACTION.TOP_GOAL)}
                                variant="primary"
                                label="Mark as top goal"
                                className="w-full"
                              />
                              <span className="ml-2 mt-[3px] absolute top-[24%] right-[31%]">
                                <WhiteCheck />
                              </span>
                            </div>

                            <div className="w-full mt-2">
                              {/* check-button -- clean up custom style */}
                              <Button
                                onClick={() => handleUserGoal(GOAL_ACTION.INACTIVE)}
                                variant="secondary"
                                className="outline-black !text-black w-full"
                                label="Make this goal inactive"
                              />
                            </div>
                          </>
                        )}
                      </>
                    ) : (
                      <div className="w-full">
                        <Button
                          onClick={() => handleUserGoal(GOAL_ACTION.ACTIVE)}
                          label="Mark this goal as active"
                          variant="primary"
                          className="w-full"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
